import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';
import * as Util from '../../common/utilities';

import { Spinner } from '@salesforce/design-system-react';

import './Home.scss';

export class Home extends Component {
  componentDidMount() {
    this.props.actions.getAssetTypes();
  }

  hasData() {
    const { types } = this.props.assets.data;
    return types && types.length > 0;
  }

  uploadSkipped() {
    return localStorage.getItem('userSkippedUpload');
  }

  componentDidUpdate(prevProps) {
    // we just finished loading assetTypes
    if (Util.propChanged(prevProps, this.props, 'assets.isLoading', false)) {
      const path =
        this.hasData() || this.uploadSkipped()
          ? '/root/distribution'
          : '/root/settings';
      this.props.history.replace(path);
    }
  }

  render() {
    return (
      <div>
        <div className="pi-common-spinner">
          <Spinner variant="brand" />
        </div>
      </div>
    );
  }
}

Home.contextTypes = {
  router: PropTypes.object
};

Home.propTypes = {
  assets: PropTypes.object.isRequired,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    assets: state.ecs.assets
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
